module.exports = __webpack_public_path__ + "img/a2-s32.4bdee2c9.jpg";